
import { post } from "../utils/request";
import { normTypesV1, normTypesV2 } from "./utilData";

// 获取当前季度
export const getSeason = () => {
  let month = new Date().getMonth();
  // 0表示1月，1表示2月一次类推
  let season = Math.floor(month / 3) + 1;
  if (season == 1) {
    return "第一季度";
  } else if (season == 2) {
    return "第二季度";
  } else if (season == 3) {
    return "第三季度";
  } else if (season == 4) {
    return "第四季度";
  }
}

// 获取当前季度（数字）
export const getSeasonNum = () => {
  let month = new Date().getMonth();
  // 0表示1月，1表示2月一次类推
  let season = Math.floor(month / 3) + 1;
  return season;
}

export const seasonTransfer = (season) => {
  if (season == 1) {
    return "第一季度";
  } else if (season == 2) {
    return "第二季度";
  } else if (season == 3) {
    return "第三季度";
  } else if (season == 4) {
    return "第四季度";
  }
}

// 角色转换，只用在表格的formatter中
export const getRoleName = (role) => {
  if (sessionStorage.getItem("roleMap") == null || sessionStorage.getItem("roleMap") == "") {
    post("/role/search").then((res) => {
      if (res.code == 200) {
        sessionStorage.setItem("roleMap", res.data.roleMap);
      }
    })
  }
  let roleMap = JSON.parse(sessionStorage.getItem("roleMap"));
  if (role instanceof Object) {
    let roleName = [];
    for (let i = 0, len = role.length; i < len; i++) {
      for (let j = 0, len = roleMap.length; j < len; j++) {
        if (parseInt(role[i]) == roleMap[j].roleId) {
          roleName[i] = roleMap[j].roleName;
        }
      }
    }
    return roleName.join(',');
  } else {
    if (role instanceof String) {
      role = parseInt(role);
    }
    for (let i = 0, len = roleMap.length; i < len; i++) {
      if (roleMap[i].roleId == role) {
        return roleMap[i].roleName;
      }
    }
  }
}

// 任务类型
export const getTaskTypeName = (taskTypeId) => {
  taskTypeId = parseInt(taskTypeId);
  if (taskTypeId == 1) {
    return "日常工作";
  } else if (taskTypeId == 2) {
    return "临时工作";
  } else if (taskTypeId == 3) {
    return "重点工作";
  } else {
    return "其他工作";
  }
}

// 指标类型
export const getNormTypeName = (normTypeId) => {
  normTypeId = parseInt(normTypeId);
  if (normTypeId == 1) {
    return "共性指标";
  } else if (normTypeId == 3) {
    return "关键指标";
  } else if (normTypeId == 4) {
    return "加减分";
  } else if (normTypeId == 5) {
    return "民主测评";
  } else if (normTypeId == 6) {
    return "服务对象测评";
  } else {
    return "显示错误";
  }
}

// 根据数据数组下标截取数据
// data或indexArr为空数组则返回空数组
export const subArray = (data, indexArr) => {
  let res = [];
  if (data.length == 0 || indexArr.length == 0) {
    return res;
  }
  for (let i = 0; i < indexArr.length; i++) {
    res.push(data[indexArr[i]]);
  }
  return res;

}

// version == x从normTypesVx中查询
export const getNormNameByTypeId = (normType, version) => {
  if (version === 1) {
    for (let i = 0; i < normTypesV1.length; i++) {
      if (normTypesV1[i].value == normType) {
        return normTypesV1[i].label;
      }
    }
  } else {
    for (let i = 0; i < normTypesV2.length; i++) {
      if (normTypesV2[i].value == normType) {
        return normTypesV2[i].label;
      }
    }
  }

  return null;
}